/*
colorsObj properties:
  - id
  - first
  - second
  - third
  - fourth
  - fifth
  - sixth
 */
class Colors {
  constructor(colorsObj) {
    this.obj = null;

    if (colorsObj) {
      this.obj = colorsObj;
    }
  }

  /**
   *
   * @returns {boolean}
   */
  hasLoaded() {
    return !!this.obj;
  }
}

export default Colors;
